import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled.div(() =>
  mq({
    height: '100%',
    textAlign: 'center',
    '& > h2': {
      fontSize: defaultTheme.font.size.l,
      color: defaultTheme.color.secondary,
      fontWeight: 'bold',
      marginBottom: defaultTheme.spacing.xxl,
    },
    '& > h3': {
      fontSize: defaultTheme.font.size.m,
      color: defaultTheme.color.secondary,
      fontWeight: 'bold',
      marginTop: defaultTheme.spacing.xxl,
      marginBottom: defaultTheme.spacing.l,
    },
    '& > p': {
      fontSize: defaultTheme.font.size.s,
      color: defaultTheme.color.secondary,
      marginBottom: defaultTheme.spacing.l,
    },
    '& > img': {
      width: ['295px', '295px', '240px', '240px'],
    },
  }),
);
